<template>
  <input
    class="form-control"
    v-model="model"
    :class="{ 'is-invalid': hasError }"
    :type="type"
    :placeholder="placeholder"
    @input="applyMask"
  />
</template>

<script setup lang="ts">
import { handleMask } from "@/utils";

export type InputProps = {
  type?: string;
  hasError?: boolean;
  placeholder?: string;
};

const {
  type = "text",
  hasError = false,
  placeholder = "",
} = defineProps<InputProps>();

const emit = defineEmits(["update:modelValue"]);
const model = defineModel<string>();

const applyMask = (event: Event) => {
  const target = event.target as HTMLInputElement;

  // Aplica a máscara
  const maskedValue = handleMask(event);

  // Atualiza o valor do input e o modelo
  target.value = maskedValue;
  model.value = maskedValue; // Isso irá emitir automaticamente o evento do v-model
};
</script>
